import { sanitizeData, sanitizeExpire } from './Sanitize'

const init = {
  isLoading: false,
  isStatus: true,
  expireToken: false,
  data: false,
}

const actionTypes = {
  FETCH_TRANSACTION_DETAIL: 'FETCH_TRANSACTION_DETAIL',
  RESET: 'RESET',
}

const fetchReset = async state => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}
const fetchTransactionDetail = async (state, transactiondetail) => {
  state = {
    ...state,
    isStatus: transactiondetail.status,
    expireToken: sanitizeExpire({
      status: transactiondetail.status,
      data: transactiondetail.data,
      name: 'transactiondetailobj',
    }),
    data: sanitizeData({
      status: transactiondetail.status,
      data: transactiondetail.data,
      name: 'transactiondetailobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TRANSACTION_DETAIL:
      return fetchTransactionDetail(state, action.transactiondetail)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const transactiondetail = {
  init,
  actionTypes,
  reducer,
}

export default transactiondetail
